"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.APosAdOverlayEffectSchema = exports.APosAdSlideTypeSchema = exports.APosAdPlaylistStatusSchema = exports.APosAdDisplayStatusSchema = exports.APosAdPrioritySchema = exports.APosAdThemeSchema = exports.APosAdAnimationSchema = void 0;
const zod_1 = require("zod");
exports.APosAdAnimationSchema = zod_1.z.enum([
    'none',
    'fade-in',
    'slide-in-left',
    'slide-in-right',
    'slide-in-up',
    'slide-in-down',
    'zoom-in',
    'zoom-out',
    'bounce',
    'pop',
    'flip',
    'pulse',
    'glow',
    'shake',
    'typewriter',
    'bumpy',
]);
exports.APosAdThemeSchema = zod_1.z.enum([
    'amber',
    'red',
    'pink',
    'purple',
    'emerald',
    'blue',
    'gradient-warm',
    'gradient-cool',
    'dark',
]);
exports.APosAdPrioritySchema = zod_1.z.enum(['P1', 'P2', 'P3']);
exports.APosAdDisplayStatusSchema = zod_1.z.enum(['pending', 'activated', 'released']);
exports.APosAdPlaylistStatusSchema = zod_1.z.enum(['draft', 'published', 'archived']);
exports.APosAdSlideTypeSchema = zod_1.z.enum(['product', 'video', 'image', 'text']);
// Decorative overlay layer rendered on top of any slide. None by default.
exports.APosAdOverlayEffectSchema = zod_1.z.enum([
    'none',
    'falling-stars',
    'snow',
    'confetti',
    'sparkles',
    'bubbles',
    'fireworks',
    'hearts',
    'rain',
]);
//# sourceMappingURL=enums.js.map